if (!customElements.get('skya-steps-rail')) {
  const DRAG_THRESHOLD = 6;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class SkyaStepsRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.skya-steps__cards');
      this.controls = this.querySelector('.skya-steps__controls');
      [this.prev, this.next] = this.controls.querySelectorAll('button');
      this.update = this.update.bind(this);
      this.controls.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (button) this.step(Number(button.dataset.direction));
      });
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.step(event.key === 'ArrowRight' ? 1 : -1);
      });
      new ResizeObserver(this.update).observe(this.track);
      this.bindDrag();
      this.update();
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      this.controls.hidden = maxScroll <= 0;
      this.prev.disabled = this.track.scrollLeft <= 0;
      this.next.disabled = this.track.scrollLeft >= maxScroll;
    }

    step(direction) {
      const card = this.track.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: direction * distance, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }

    bindDrag() {
      let drag = null;
      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { id: event.pointerId, startX: event.clientX, startScroll: this.track.scrollLeft, moved: false };
      });
      this.track.addEventListener('pointermove', (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        const delta = event.clientX - drag.startX;
        if (!drag.moved && Math.abs(delta) < DRAG_THRESHOLD) return;
        if (!drag.moved) {
          drag.moved = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(drag.id);
        }
        this.track.scrollLeft = drag.startScroll - delta;
      });
      const end = (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        if (drag.moved) this.track.classList.remove('is-dragging');
        drag = null;
      };
      this.track.addEventListener('pointerup', end);
      this.track.addEventListener('pointercancel', end);
      this.track.addEventListener('dragstart', (event) => event.preventDefault());
    }
  }

  customElements.define('skya-steps-rail', SkyaStepsRail);
}
